<template>
  <div class="page game-page">
    <van-nav-bar class="nav-bar nav-bar-gradient" :title="$t('reservation.hall')" />

    <div class="game-layout">
      <div class="sidebar">
        <van-sidebar @change="onChange" v-model="activeKey">
          <van-sidebar-item :title="$t('index.all')" />
          <van-sidebar-item v-for="(v,key) in lotteryitem" :key="key" :title="v.name" />
        </van-sidebar>
      </div>

      <div class="game-content">
        <van-pull-refresh :border="false" v-model="isLoading" @refresh="onRefresh">
          <van-grid :column-num="2" :gutter="12">
            <van-grid-item @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
              <div class="game-card">
                <van-image class="game-icon" :src="v.ico">
                  <template v-slot:loading>
                    <van-loading type="circular" />
                  </template>
                </van-image>
                <span class="game-name">{{v.name}}</span>
                <span class="game-desc">{{v.desc}}</span>
              </div>
            </van-grid-item>
          </van-grid>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      gameitem: [{},{},{},{}],
      lotteryitem: [{},{},{},{}],
      isLoading: false,
      activeKey: 0,
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data:{class:index},
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    getLotteryItem(){
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res=>{
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
    this.getGameItem();
    this.getLotteryItem();
  }
};
</script>

<style lang='less' scoped>
.game-page {
  display: flex;
  flex-direction: column;
  background: #f6f5f2;
  padding-bottom: 0;
}

.game-layout {
  display: flex;
  flex: 1;
  min-height: calc(100vh - var(--nav-bar-height) - var(--tabbar-height));
}

.sidebar {
  width: 160px;
  background: rgba(255,255,255,.78);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-right: 1px solid rgba(17,24,39,.06);
  overflow-y: auto;
}

.van-sidebar {
  width: 100%;
}

.van-sidebar-item {
  font-size: 26px;
  padding: 32px 16px;
  background: transparent;
  text-align: center;
}

.van-sidebar-item--select {
  color: var(--primary);
  font-weight: 700;
  background: rgba(124,111,240,.08);
}

.van-sidebar-item--select::before {
  left: 6px;
  height: 40%;
  width: 6px;
  background: var(--primary);
  border-radius: 999px;
}

/deep/ .van-sidebar-item__text {
  width: 100%;
  margin-left: 0;
}

.game-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.game-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px;
  background: rgba(255,255,255,.74);
  border-radius: var(--radius-md);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,.72);
  box-shadow: var(--shadow-soft);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.game-icon {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
}

.game-name {
  font-size: 24px;
  font-weight: 600;
  color: var(--text);
}

.game-desc {
  font-size: 20px;
  color: var(--muted);
}

::v-deep .van-grid-item__content {
  padding: 0;
  background: transparent;
}
</style>